module.exports = __webpack_public_path__ + "images/macbook-es-0394b1.png";